const language = {
    'pt': 
        {
            accepted:           'Aprovado',
            add_new:            'Adicionar novo',
            address:             'Morada',
            address_placeholder: 'Introduza a morada',
            age:                'Idade',
            age_placeholder:                'Introduza a idade',
            back:               'Voltar',
            business_sector:    'Setor de atividade',
            business_sector_placeholder:    'Introduza o setor de atividade',
            cancel:             'Cancelar',
            close:              'Fechar',
            config:             'Configuração',
            contact_email:      'Email de contacto',
            contact_email_placeholder:      'Introduza o email de contacto',
            content:            'Conteúdo',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de conteúdos',
            dark_mode:               'Dark mode',
            dates:              'Datas',
            date_birth:         'Data de nascimento',
            date_birth_placeholder:         'Introduza a data de nascimento',
            date_creation:      'Criação',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            description_placeholder: 'Introduza uma descrição',
            documents:          'Documentos',
            empregado:          'Empregado',
            desempregado:       'Desempregado',
            doc_choose:         'Escolher ficheiro',
            doc_certificate:    'Certificado de Habilitações (ou documento equivalente)',
            doc_desempregado:   'Apresentação da declaração actualizada do IEFP em como se encontra desempregado há menos de 12 meses ou apresentação de declaração da Seg. Social, acompanhada de declaração do próprio formando, atestando que está à procura de emprego e desde quando',
            doc_emprego:            'Declaração da entidade empregadora ou recibo verde do mês anterior ao início da formação ou declaração da Segurança Social',
            doc_emprego_horario:    'Comprovativo do horário de trabalho diário (declaração da entidade empregadora ou próprio, se empregado por conta própria)',
            doc_iban:           'IBAN (documento bancário com identificação do/a titular)',
            doc_id:             'Cartão de Cidadão ou BI + NIF + NISS',
            doc_attach_empty:   'Sem ficheiro anexado',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_text_2:         'Ao atualizar os seus dados, concorda com os nossos ',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            educational_background: 'Habilitações académicas',
            email:              'E-mail',
            email_contact:      'E-mail preferencial de contacto',   
            email_error_message:  'Campo inválido. Inclua um "@" no endereço de e-mail.',
            employer_entity:    'Entidade patronal',
            employer_entity_placeholder:  'Introduza a entidade patronal',
            employment_role:    'Função desempenhada',
            employment_role_placeholder:    'Introduza a função desempenhada',
            employment_status:  'Situação profissional',
            entity:             'Formando',  
            entity_edit:        'Editar formando',                
            entity_new:         'Novo formando',                
            entity_list:        'Lista de formandos', 
            entrepreneur:               'Empreendedor',
            entrepreneur_edit:          'Editar empreendedor',
            entrepreneur_list:          'Lista de Empreendedores',
            file_remove:        'Remover ficheiro',
            filter_placeholder: 'Procurar',
            formation_area:     'Área de formação',
            formation_area_placeholder:  'Introduza a área de formação',
            formation_registration: 'Inscrição',
            formation_registration_2: 'Inscrição em cursos',
            formation_registration_finish: 'Finalizar inscrição',
            formation_registration_finish_error: 'Problema ao finalizar pedido de inscrição',
            formation_registration_required_files_warning1: 'Tem que anexar os seguintes documentos para finalizar a sua inscrição:</br> <b>Cartão de Cidadão ou BI + NIF + NISS</br> Certificado de Habilitações (ou documento equivalente)</b>',
            formation_registration_required_files_warning2: 'Tem que anexar os seguintes documentos para finalizar a sua inscrição:</br> <b>Cartão de Cidadão ou BI + NIF + NISS</br> Certificado de Habilitações (ou documento equivalente)</br> IBAN (documento bancário com identificação do/a titular)</b>',
            formation_registration_finish_text: 'Vai finalizar o pedido de inscrição no curso ',
            formation_registration_finish_warning: 'Para finalizar a sua inscrição preencha todos os campos assinalados com (<span style="color: var(--red)">&#42;</span>). Clique em baixo no botão "Salvar" e depois no botão "Finalizar Inscrição" quando este surgir.',
            formation_registration_remove: 'Remover inscrição',
            formation_registration_success: 'Pedido de inscrição efetuado com sucesso.</br> O seu pedido vai ser analisado e será informado(a) da sua resposta brevemente.',
            household:          'Agregado familiar',
            household_dependants:    'Nº de dependentes',
            household_dependants_placeholder: 'Introduza o nº de dependentes',
            household_inactive:    'Nº de inativos',
            household_inactive_placeholder: 'Introduza o nº de inativos',
            household_total:    'Nº de pessoas (incluir o próprio)',
            household_total_placeholder: 'Introduza o nº de pessoas',
            household_unemployed:    'Nº de desempregados',
            household_unemployed_placeholder: 'Introduza o nº de desempregados',
            id:                 'ID',
            id_number:          'Número de identificação',
            id_number_placeholder:          'Introduza o número de identificação',
            id_type:            'Tipo de Identificação',
            id_type_citizen_card: 'Cartão do Cidadão',
            id_type_identity_card: 'Bilhete de Identidade',
            id_type_passport:   'Passaporte',
            id_validity:         'Validade',
            iefp_registration_date:     'Data de inscrição no Instituto do Emprego e Formação Profissional (IEFP)',
            iefp_registration_date_placeholder:     'Introduza a data de inscrição no IEFP',
            image:              'Imagem',
            image_profile:              'Imagem de perfil',
            image_choose:       'Escolher imagem',
            image_remove:       'Remover imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            language:           'Lingua',
            login_data:         'Dados de login',
            municipality:       'Concelho',
            municipality_placeholder:       'Introduza o concelho',
            name:               'Nome',
            name_full:               'Nome completo',
            name_full_placeholder:   'Introduza o nome completo',
            name_placeholder:   'Introduza o nome',
            nib_iban_placeholder: 'Introduza o NIB/IBAN',
            nif_placeholder:    'Introduza o NIF (9 dígitos)',
            surname:            'Apelido',
            surname_placeholder:'Introduza o apelido',
            location:           'Localidade',
            location_placeholder:'Introduza a localidade',
            password:           'Password',
            password_confirmation:  'Confirmação da Password',
            password_placeholder:   'Introduza a password',
            password_title:     'Password!',
            password_text:      'As Passwords não correspondem.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Dados pessoais',
            phone_number:       'Contacto telefónico',
            phone_number_placeholder:       'Introduza o contacto telefónico',
            place_birth:        'Naturalidade',
            place_birth_placeholder:        'Introduza a naturalidade',
            postal_code:        'Código-postal',
            postal_code_placeholder:       '9999-999',
            principal:          'Principal',
            professional_area:  'Área profissional',
            professional_area_placeholder:  'Introduza a área profissional',
            profile:            'Perfil',
            rejected:           'Não aprovado',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_thumbnail:    'Thumbnail',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_type:         'Tipo',
            table_count:        'Count',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            terms_conditions_link:   'termos e condições.',
            terms_conditions_required: 'Os campos assinalados com (<span className="text-danger">&#42;</span>) são de preenchimento obrigatório.',
            text:               'Texto',
            trainee:            'Formando',
            trainee_list:       'Lista de formandos',
            title:              'Título',
            title_placeholder:  'Introzuda o título',
            save:               'Salvar', 
            under_review:       'Em análise',
            username:           'Username', 
            username_email:     'Email de utilizador',
            username_placeholder: 'Introduza o username', 
            view:               'Ver',
            village:            'Freguesia',
            village_placeholder:            'Introduza a freguesia',
            warning_title:      'Aviso!',
            warning_text_1:       'Já existe um registo com este email de utilizador.',
            warning_text_2:       'Já existe um registo com este email de contacto.',
            warning_confirm:    'Continuar',
            warning_cancel:     'Não',
            warning_error:      'Problema ao inserir registo!',
            warning_success:    'Registo inserido com sucesso!',             
        },
    'en':
        {
            accepted:           'Aprovado',
            add_new:            'Add new',
            address:             'Address',
            address_placeholder: 'Insert address',
            age:                'Age',
            age_placeholder:                'Insert age',
            back:               'Go back',
            business_sector:    'Business sector',
            business_sector_placeholder:    'Insert business sector',
            cancel:             'Cancel',
            close:              'Close',
            config:              'Clonfiguration',
            content:            'Content',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Content list',
            dates:              'Dates',
            date_birth:         'Data of birth',
            date_birth_placeholder:         'Insert the date o birth',
            date_creation:      'Creation',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            description_placeholder: 'Insert a description',
            documents:          'Documentos',
            empregado:          'Empregado',
            desempregado:       'Desempregado',
            doc_choose:         'Escolher ficheiro',
            doc_certificate:    'Certificado de Habilitações (ou documento equivalente)',
            doc_desempregado:   'Apresentação da declaração actualizada do IEFP em como se encontra desempregado há menos de 12 meses ou apresentação de declaração de Seg. Social, acompanhada de declaração do próprio formando, atestando que está à procura de emprego e desde quando',
            doc_emprego:            'Declaração da entidade empregadora ou recibo verde do mês anterior ao início da formação ou declaração da Segurança Social',
            doc_emprego_horario:    'Comprovativo do horário de trabalho diário (declaração da entidade empregadora ou próprio, se empregado por conta própria)',
            doc_iban:           'IBAN (documento bancário com identificação do/a titular)',
            doc_id:             'Cartão de Cidadão ou BI + NIF + NISS',
            doc_attach_empty:   'No attached file',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_text_2:         'By updating your information, you agree with your ',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            educational_background: 'Educacional background',
            email:              'E-mail',
            email_contact:      'Contact e-mail',   
            email_error_message:  'Invalid field. Include an "@" in the email address.',
            employer_entity:    'Employer entity',
            employer_entity_placeholder:  'Insert employer entity',
            employment_role:    'Employment role',
            employment_role_placeholder:    'Insert employment role',
            employment_status:  'Employment status',
            entity:             'Trainee', 
            entity_edit:        'Edit trainee', 
            entity_new:         'New trainee', 
            entity_list:        'Trainee List', 
            entrepreneur:       'Entrepeneur',
            entrepreneur_edit:  'Edit entrepeneur',
            entrepreneur_list:  'Entrepeneur List',
            file_remove:        'Remove file',
            filter_placeholder: 'Search',
            formation_area:     'Formation area',
            formation_area_placeholder:  'Insert formation area',
            formation_registration: 'Registration',
            formation_registration_2: 'Inscrição em cursos',
            formation_registration_finish: 'Finish registration',
            formation_registration_finish_error: 'Problem finishing registration request',
            formation_registration_required_files_warning1: 'Tem que anexar os seguintes documentos para finalizar a sua inscrição: Cartão de Cidadão ou BI + NIF + NISS e Certificado de Habilitações (ou documento equivalente).',
            formation_registration_required_files_warning2: 'Tem que anexar os seguintes documentos para finalizar a sua inscrição: Cartão de Cidadão ou BI + NIF + NISS, Certificado de Habilitações (ou documento equivalente) e IBAN (documento bancário com identificação do/a titular).',
            formation_registration_finish_text: 'Vai finalizar o pedido de inscrição no curso ',
            formation_registration_finish_warning: 'Para finalizar a sua inscrição preencha todos os campos assinalados com (<span style="color: var(--red)">&#42;</span>). Clique em baixo no botão "Salvar" e depois no botão "Finalizar Inscrição" quando este surgir.',
            formation_registration_remove: 'Remove registration',
            formation_registration_success: 'Pedido de inscrição efetuado com sucesso.</br> O seu pedido vai ser analisado e será informado(a) da sua resposta brevemente.',
            household:          'Household',
            household_dependants:    'Number of dependants',
            household_dependants_placeholder: 'Insert number of dependants',
            household_inactive:    'Number of inactives',
            household_inactive_placeholder: 'Insert nymber of inactives',
            household_total:    'Total number(include your own)',
            household_total_placeholder: 'Insert total number',
            household_unemployed:    'Total of unemployed',
            household_unemployed_placeholder: 'Insert total of unemployed',
            id:                 'ID',
            id_number:          'Identification Number',
            id_number_placeholder:          'Insert identification number',
            id_type:            'Identification Type',
            id_type_citizen_card: 'Citizen Card',
            id_type_identity_card: 'Identity Card',
            id_type_passport:   'Passaport',
            id_validity:         'Validity',
            iefp_registration_date:     'Data de inscrição no Instituto do Emprego e Formação Profissional (IEFP)',
            iefp_registration_date_placeholder:     'Introduza a data de inscrição no IEFP',
            language:           'Language',
            login_data:         'Login data',
            municipality:       'Municipality',
            municipality_placeholder:       'Insert municipality',
            name:               'Name',
            name_full:          'Full name',
            name_full_placeholder:          'Insert full name',
            name_placeholder:   'Insert the name',
            nib_iban_placeholder: 'Insert NIB/IBAN',
            nif_placeholder:    'Insert NIF (9 digits)',
            surname:            'Apelido',
            surname_placeholder:'Introduza o apelido',
            location:           'Location',
            location_placeholder:'Insert location',
            contact_email:      'Contact email',
            contact_email_placeholder:    'Insert email contact',
            image:              'Image',
            image_profile:      'Profile image',
            image_choose:       'Choose imagem',
            image_remove:       'Remove image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            password:           'Password',
            password_confirmation: 'Password confirmation',
            password_placeholder:   'Insert password',
            password_title:     'Password!',
            password_text:      'The password do not match.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Personal data',
            phone_number:       'Phone number',
            phone_number_placeholder:       'Insert your phone number',
            place_birth:        'Place of birth',
            place_birth_placeholder:        'Insert place of birth',
            postal_code:        'Postal code',
            postal_code_placeholder:       '9999-999',
            principal:          'Principal',
            professional_area:  'Professional area',
            professional_area_placeholder:  'Insert professional area',
            profile:            'Profile',
            rejected:           'Rejected',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_thumbnail:    'Thumbnail',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_type:         'Type',
            table_count:        'Count',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            terms_conditions_link:   'terms and conditions.',
            terms_conditions_required: 'The fields marked with (<span style="color: var(--red)">&#42;</span>) are required.',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            trainee:            'Trainee',
            trainee_list:       'Trainee list',
            save:               'Save',
            under_review:       'Under review',
            username:           'Username',
            username_email:     'Username email', 
            username_placeholder: 'Insert the username',
            view:               'View',
            village:            'Village',
            village_placeholder:            'Insert village',
            warning_title:      'Warning!',
            warning_text_1:       'There is already a record with this username email.',
            warning_text_2:       'There is already a record with this contact email.',
            warning_confirm:    'Continue',
            warning_cancel:     'No',
            warning_error:      'Problem inserting element!',
            warning_success:    'Successful inserted element!', 
        }
}

module.exports = {
    language
};